import React from "react";

import { OrderContactButton } from "../OrderContactButton";
import { OrderTabDocumentStatus } from "../OrderTabDocumentStatus";
import { TabSelected } from "../useOrderPageTabs";
import { OrderTabRightComponentContainer, OrderTabRightComponentDocumentContainer } from "./styles";

interface OrderTabRightComponentProps {
  currentTabName: TabSelected;
}

export const OrderTabRightComponent = ({ currentTabName }: OrderTabRightComponentProps) => {
  return (
    <OrderTabRightComponentContainer>
      {currentTabName.toLowerCase() === TabSelected.SUMMARY.toLowerCase() ? (
        <OrderTabRightComponentDocumentContainer>
          <OrderTabDocumentStatus />
        </OrderTabRightComponentDocumentContainer>
      ) : null}
      <OrderContactButton />
    </OrderTabRightComponentContainer>
  );
};
